export default __webpack_public_path__ + "static/media/轮播首图12.b0cba5d5.jpg";